import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { GlobalStoreService } from '../../../services/global-store/global-store.service';
import { GestionTitreService } from 'src/app/services/navigation/gestion-titre.service';
import { CybermetrieCoordonneesService } from '../../../services/cybermetrie/cybermetrie.service';
import { ErreurSummary } from '../../../models/erreurs/erreur-summary';
import { Router } from '@angular/router';
import { TypeChangementEnum } from '../../../constantes/type-changement.enum';
import { StateModifier } from '../../../models/state/state-modifier.model';
import { CoordonneesClient } from 'src/app/api/model/coordonnees-client.model';
import { CompteDetention } from 'src/app/api/model/compte-detention.model';
import { InfosCarteTypeCarteEnum } from 'src/app/api/model/infos-carte.model';
import { GabaritService } from 'src/app/services/gabarit/gabarit.service';

@Component({
  selector: 'app-modifier-hogan',
  templateUrl: './modifier-hogan.component.html',
  standalone: false,
})
export class ModifierHoganComponent implements OnInit {
  erreursSummary: ErreurSummary[];
  titre: string = '';
  typeChangement: string;
  state?: StateModifier;
  coordonneesClient: CoordonneesClient;
  compteActif?: CompteDetention;
  isAppMobile: boolean;
  doitAfficherAvertissementNumeroTelephonePrepayee: boolean;

  constructor(
    public readonly navigationService: NavigationService,
    protected globalStoreService: GlobalStoreService,
    protected gestionTitreService: GestionTitreService,
    router: Router,
    protected cybermetrieCoordonneesService: CybermetrieCoordonneesService,
    private readonly gabaritService: GabaritService
  ) {
    this.state = router.lastSuccessfulNavigation?.extras?.state as StateModifier;
  }

  ngOnInit(): void {
    this.isAppMobile = this.gabaritService.isAppMobile();
    this.globalStoreService.saveEtatModification(null);
    if (this.state?.type != null) {
      this.typeChangement = this.state.type;
      this.compteActif = this.state.compteDetention;
      this.globalStoreService.saveFlowChangement(this.typeChangement);
    } else {
      this.typeChangement = this.globalStoreService.getFlowChangement();
    }
    this.globalStoreService.getCoordonneesClient$().subscribe((data) => {
      this.coordonneesClient = data;
      this.doitAfficherAvertissementNumeroTelephonePrepayee =
        this.isTelephone &&
        this.coordonneesClient?.comptesDetention?.find(
          (compte) => compte.infosCarte?.typeCarte === InfosCarteTypeCarteEnum.PREPAYEE
        ) != null;
    });
    this.globalStoreService.getErrorsForm().subscribe((erreurSummary) => (this.erreursSummary = erreurSummary));
    this.titre = this.getTitle();
    this.gestionTitreService.addTitreOnglet(this.getTitleOnglet());
  }

  private getTitle(): string {
    switch (this.typeChangement) {
      case TypeChangementEnum.COURRIEL:
        return 'caad.modifier.courriel.' + this.getTitleCourriel();
      case TypeChangementEnum.TELEPHONE:
        return 'caad.modifier.telephone.' + this.getTitleTelephone();
      default:
        return 'caad.modifier.coordonnees.titre';
    }
  }

  private getTitleOnglet(): string {
    switch (this.typeChangement) {
      case TypeChangementEnum.COURRIEL:
        return 'caad.titreOnglet.COURRIEL.' + this.getTitleCourriel();
      case TypeChangementEnum.TELEPHONE:
        return 'caad.titreOnglet.TELEPHONE.' + this.getTitleTelephone();
      default:
        return 'caad.titreOnglet.COORDONNEES';
    }
  }

  private getTitleTelephone(): string {
    const numberOfTelephones = this.coordonneesClient?.telephones?.length ?? 0;
    switch (numberOfTelephones) {
      case 0:
        return 'titreAjout';
      case 1:
        return 'titre';
      default:
        return 'titreTelephones';
    }
  }

  private getTitleCourriel(): string {
    let libelle = 'titreAjout';
    if (
      this.compteActif
        ? this.compteActif.infosCompte.adresseCourriel
        : this.coordonneesClient?.comptesDetention?.[0].infosCompte.adresseCourriel
    ) {
      libelle = 'titre';
    }
    return libelle;
  }

  protected isCoordonnees(): boolean {
    return this.typeChangement === TypeChangementEnum.COORDONNEES;
  }

  protected isCourriel() {
    return this.typeChangement === TypeChangementEnum.COURRIEL;
  }

  protected isTelephone() {
    return this.typeChangement === TypeChangementEnum.TELEPHONE;
  }
}
